module.exports = "/_next/static/images/Cover@2x-7abd7e880cb8d03c0b4b259ab83e9333.webp";